import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  IconButton
} from '@mui/material';
import {
  Close as CloseIcon,
  Warning as WarningIcon,
  Error as ErrorIcon,
  Info as InfoIcon,
  CheckCircle as SuccessIcon
} from '@mui/icons-material';

const ConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  title = '¿Estás seguro?',
  content = 'Esta acción no se puede deshacer.',
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  severity = 'warning', // 'warning', 'error', 'info', 'success'
  confirmButtonColor = 'error',
  loading = false,
  maxWidth = 'sm'
}) => {
  const getIcon = () => {
    const iconProps = { sx: { fontSize: 48, mb: 2 } };
    
    switch (severity) {
      case 'error':
        return <ErrorIcon color="error" {...iconProps} />;
      case 'info':
        return <InfoIcon color="info" {...iconProps} />;
      case 'success':
        return <SuccessIcon color="success" {...iconProps} />;
      case 'warning':
      default:
        return <WarningIcon color="warning" {...iconProps} />;
    }
  };

  const getColor = () => {
    switch (severity) {
      case 'error':
        return 'error.main';
      case 'info':
        return 'info.main';
      case 'success':
        return 'success.main';
      case 'warning':
      default:
        return 'warning.main';
    }
  };

  const handleConfirm = () => {
    onConfirm();
  };

  const handleClose = () => {
    if (!loading) {
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={maxWidth}
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 1
        }
      }}
    >
      <DialogTitle sx={{ p: 3, pb: 1 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" fontWeight="600">
            {title}
          </Typography>
          <IconButton
            onClick={handleClose}
            disabled={loading}
            sx={{ color: 'grey.500' }}
            aria-label="Cerrar modal"
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ px: 3, py: 2, textAlign: 'center' }}>
        {getIcon()}
        
        <Typography 
          variant="body1" 
          color="text.secondary"
          sx={{ mb: 1 }}
        >
          {content}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 3, pt: 1, gap: 1 }}>
        <Button
          onClick={handleClose}
          variant="outlined"
          color="inherit"
          disabled={loading}
          sx={{ minWidth: 100 }}
        >
          {cancelText}
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color={confirmButtonColor}
          disabled={loading}
          sx={{ minWidth: 100 }}
        >
          {loading ? 'Procesando...' : confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;